import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
app.use(ElementPlus, { locale: zhCn })

app.config.errorHandler = (err, instance, info) => {
  const errorMessage = err?.message || err?.toString() || ''
  if (errorMessage.includes('ResizeObserver') || errorMessage.includes('ResizeObserver loop')) {
    return
  }
  console.error(err, instance, info)
}

const originalError = window.onerror
window.onerror = function(message, source, lineno, colno, error) {
  if (typeof message === 'string' && (message.includes('ResizeObserver') || message.includes('ResizeObserver loop'))) {
    return true
  }
  if (originalError) {
    return originalError.call(this, message, source, lineno, colno, error)
  }
  return false
}

window.addEventListener('error', (event) => {
  const errorMessage = event.message || event.error?.message || ''
  if (errorMessage.includes('ResizeObserver') || errorMessage.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation()
    event.preventDefault()
    return false
  }
}, true)

window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || event.reason?.toString() || ''
  if (errorMessage.includes('ResizeObserver') || errorMessage.includes('ResizeObserver loop')) {
    event.preventDefault()
    return false
  }
})

app.mount('#app')

